/**
 * Mckay-brothers Portal
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpResponse} from '@angular/common/http';

import {Observable} from 'rxjs';


import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {RequestHistoricalData} from '../model/request-historical-data';


@Injectable()
export class HistoryRequestService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Removes the HistoryRequest resource.
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteHistoryRequestItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;

  public deleteHistoryRequestItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;

  public deleteHistoryRequestItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;

  public deleteHistoryRequestItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteHistoryRequestItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.delete<any>(`${this.basePath}/api/history_requests/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves the collection of HistoryRequest resources.
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getHistoryRequestCollection(observe?: 'body', reportProgress?: boolean): Observable<Array<RequestHistoricalData>>;

  public getHistoryRequestCollection(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RequestHistoricalData>>>;

  public getHistoryRequestCollection(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RequestHistoricalData>>>;

  public getHistoryRequestCollection(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Array<RequestHistoricalData>>(`${this.basePath}/api/history-request`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves a HistoryRequest resource.
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getHistoryRequestItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<RequestHistoricalData>;

  public getHistoryRequestItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RequestHistoricalData>>;

  public getHistoryRequestItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RequestHistoricalData>>;

  public getHistoryRequestItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getHistoryRequestItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<RequestHistoricalData>(`${this.basePath}/api/history_requests/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a HistoryRequest resource.
   *
   * @param historyRequest The new HistoryRequest resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postHistoryRequestCollection(historyRequest?: RequestHistoricalData, observe?: 'body', reportProgress?: boolean): Observable<RequestHistoricalData>;

  public postHistoryRequestCollection(historyRequest?: RequestHistoricalData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RequestHistoricalData>>;

  public postHistoryRequestCollection(historyRequest?: RequestHistoricalData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RequestHistoricalData>>;

  public postHistoryRequestCollection(historyRequest?: RequestHistoricalData, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/json'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<RequestHistoricalData>(`${this.basePath}/api/history-request`,
      historyRequest,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Replaces the HistoryRequest resource.
   *
   * @param id
   * @param historyRequest The updated HistoryRequest resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public putHistoryRequestItem(id: string, historyRequest?: RequestHistoricalData, observe?: 'body', reportProgress?: boolean): Observable<RequestHistoricalData>;

  public putHistoryRequestItem(id: string, historyRequest?: RequestHistoricalData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RequestHistoricalData>>;

  public putHistoryRequestItem(id: string, historyRequest?: RequestHistoricalData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RequestHistoricalData>>;

  public putHistoryRequestItem(id: string, historyRequest?: RequestHistoricalData, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling putHistoryRequestItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<RequestHistoricalData>(`${this.basePath}/api/history_requests/${encodeURIComponent(String(id))}`,
      historyRequest,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

}
